var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.attachment && _vm.key)?_c('div',{staticClass:"biodigital-component-container"},[_c('iframe',{attrs:{"id":_vm.iframeId,"allowfullscreen":"true","src":_vm.source}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }